import React, {Component} from 'react';
import {
  Button
} from 'reactstrap';

import { FaTimes} from 'react-icons/fa';
import urlBase from './../api/UrlBase';

class TablaGaleriaImagen extends Component {
    render(){
        const {data, eliminar} = this.props; 
        return (
            <div className="imagePreviewContainer">
                
                {
                    data.length>0 ? 
                        <div className="borde-suave">
                            <div className="destacado-cuerpo">
                                Listado de imágenes ya incluidas en la galería. <span style={{color:'red'}}>Al eliminar cada imagen se eliminaran de la galería inmediatamente.</span>
                            </div>
                            {
                                data.map(c => {
                                    return (
                                        <div key={c.id} className="dzu-previewContainer">
                                            <img src={urlBase + c.url} alt="" className="dzu-previewImage"></img>
                                            <div className="dzu-previewStatusContainer">
                                            <Button color="danger" className="btn-tabla" onClick={()=>eliminar(c.id)}><FaTimes/></Button>
                                            </div>
                                        </div>
                                    )  
                                })
                            }

                        </div>
                    : null
                }
            </div>         
        );
    }
};
export default TablaGaleriaImagen;